import React from "react";
import { makeStyles } from "@material-ui/core";
import color from "../../../assets/theme/color";
import MenuIcon from "../../../assets/img/icon/profile/MenuProfileIcon";
import BasicText from "../../atom/BasicText/BasicText";
import classNames from "classnames";
import textHelper from "../../../helper/textHelper";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  cotain: {
    backgroundColor: color.gray_8,
    padding: 21,
    display: "flex",
    alignItems: "center",
    borderRadius: 8,
  },
  icon: {
    width: 12,
    height: 17,
    color: color.gray_3,
  },
  title: {
    fontSize: "12px !important",
    fontWeight: "bold !important",
    marginBottom: "2px !important",
    textTransform: "uppercase",
  },
});
const CardEStatement = ({ className, item, onClick, id, type }) => {
  const S = useStyles();
  const { getMonthYear, getFirstAndLastDayInMount } = textHelper;
  return (
    <div
      id={id}
      className={classNames(S.cotain, "is-link", className)}
      onClick={() => onClick(item)}
    >
      <MenuIcon icon="file" className="color-secondary mt-2" />
      <div className="mx-3 flex-grow-1">
        <BasicText className={S.title}>
          {
            type === 'dividend' ? 'LAPORAN DIVIDEND' : item.title || getMonthYear(item)
          }
        </BasicText>
        <BasicText className="fs-12" colorLevel="light">
          {
            type === 'dividend' ? item.display_name : item.subtitle || getFirstAndLastDayInMount(item)
          }
        </BasicText>
      </div>
      <MenuIcon icon="download" className="color-secondary mt-2" />
    </div>
  );
};

CardEStatement.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

CardEStatement.defaultProps = {
  onClick: () => { },
};

export default CardEStatement;
